<input nbInput [placeholder]="placeholder" [nbDatepicker]="formpicker" fullWidth />
<nb-rangepicker #formpicker></nb-rangepicker>
